<template>
  <div>
    <div class="label mb-1">Історія призначень</div>
    <div class="text-disabled font-size-12 mb-4">
      {{ assignmentHistory.length }} запис(ів) в хронологічному порядку
    </div>

    <div v-if="!assignmentHistory.length" class="text-disabled font-size-13">
      Призначень не знайдено
    </div>

    <v-timeline
      v-else
      align="start"
      class="w-100"
      density="compact"
      side="end"
      truncate-line="start">
      <v-timeline-item
        v-for="(item, index) in assignmentHistory"
        :key="item.id"
        :class="index === assignmentHistory.length - 1 ? 'pb-0' : 'pb-7'"
        :dot-color="
          item.status === 'current'
            ? 'success'
            : item.status === 'future'
            ? 'blue'
            : 'grey-lighten-1'
        "
        density="compact"
        line-color="grey-lighten-2"
        min-width="100%"
        size="x-small"
        width="100%">
        <v-card
          :style="{
            background: item.status === 'current' ? '#fafcf9' : 'white',
          }"
          :class="
            item.status === 'current'
              ? 'w-100 border-green border-opacity-50'
              : 'w-100'
          "
          border
          variant="elevated">
          <v-card-text>
            <div class="d-flex justify-space-between align-start">
              <div class="flex-grow-1">
                <div class="font-size-14 font-weight-bold">
                  {{ item.position || '—' }}
                </div>
                <div class="text-disabled font-size-12 mb-2">
                  {{ item.department || '—' }}
                </div>

                <div class="d-flex align-center text-disabled font-size-12">
                  <v-icon
                    class="mr-1"
                    color="grey-darken-1"
                    icon="mdi-calendar-blank-outline"
                    size="16" />
                  {{ item.dateFrom || '—' }}
                  <span class="mx-1">—</span>
                  {{ item.dateTo || 'дотепер' }}
                </div>
              </div>

              <v-chip
                v-if="item.status === 'current'"
                class="font-weight-bold ml-2"
                color="green-lighten-5"
                size="small"
                variant="flat">
                <span class="text-green-darken-3 text-uppercase">Поточне</span>
              </v-chip>
              <v-chip
                v-else-if="item.status === 'future'"
                class="font-weight-bold ml-2"
                color="blue-lighten-5"
                size="small"
                variant="flat">
                <span class="text-blue-darken-3 text-uppercase">Майбутнє</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import { useUserCardHistoryStore } from '@/dialog/components/user-card/tabs/history/history'

export default {
  name: 'UserCardHistory',
  setup() {
    return useUserCardHistoryStore()
  },
}
</script>

<style scoped>
::v-deep(.v-timeline-item__body) {
  padding-inline-start: 10px !important;
  padding-block-end: 0 !important;
}
</style>
